import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const categoryIds = [
    "f9eb02f8-8f59-4272-99d4-eeacb98e1d92", // prod
    "94c8abad-5a4c-4d95-896d-9f0453586eaf" // acc
];

export const VeiligheidEnTechniekFilter = ({ condensed }) => {
    const filter = useFilter("opties").find((category) =>
        categoryIds.includes(category.optiecategorieId)
    );
    const count = useCount("zoekopties");
    const [value, , onChange] = useField("zoekoptieIds");

    const options =
        filter?.zoekopties?.map(({ zoekoptieId, naam }) => ({
            id: zoekoptieId,
            displayName: naam,
            aantal: count[zoekoptieId]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-veiligheid"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 3}
                datalayerKey="zoekoptieId"
                maxSize={condensed ? 5 : 0}
            />
        </Grid>
    );
};
